function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.308 5.695A5.623 5.623 0 0116.322 4c1.506 0 2.95.61 4.015 1.695A5.838 5.838 0 0122 9.785a5.839 5.839 0 01-1.663 4.09l-7.72 7.864a.862.862 0 01-1.235 0l-7.72-7.864c-2.216-2.26-2.216-5.922 0-8.18a5.603 5.603 0 018.03 0l.308.314.308-.314zM12 19.852l6.176-6.293.926-.943a4.042 4.042 0 001.152-2.831 4.044 4.044 0 00-1.152-2.832 3.893 3.893 0 00-2.78-1.174 3.893 3.893 0 00-2.78 1.174l-.925.943a.862.862 0 01-1.235 0l-.925-.943a3.88 3.88 0 00-5.56 0 4.058 4.058 0 000 5.663L12 19.852z"
});

var SvgHeart = function SvgHeart(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/heart.fe5551a1.svg";
export { SvgHeart as ReactComponent };